<script>
import { watchEffect, onUnmounted } from 'vue';

import vegaEmbed from 'vega-embed';
import { expressionInterpreter } from 'vega-interpreter';

import tooltipHandler from '@/utils/tooltipHandler';
import getLocaleConfig from '@/utils/getLocaleConfig';
import useDebugState from '@/state/useDebugState';
import useSectionState from '@/state/useSectionState';

export default {
  props: {
    spec: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String,
      default: 'chart',
    },
    currency: {
      type: [String, Object],
      default: 'USD',
    },
    ready: Boolean,
    disableHover: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update', 'error'],
  setup(props, { emit }) {
    const chartId = `#${props.id}`;

    const {
      setChartImageGetter,
      getChartById,
    } = useSectionState();

    const { chartsDebug } = useDebugState();

    const chartData = getChartById(props.id);

    const mountChart = async () => {
    // prepare current locale config

      const { currencyConfig, timeConfig } = getLocaleConfig({ currency: props.currency });

      return vegaEmbed(chartId, props.spec, {
        tooltip: tooltipHandler,
        actions: chartsDebug.value,
        ast: true,
        expr: expressionInterpreter,
        mode: 'vega-lite',
        renderer: 'svg',
        logLevel: 'Error',
        // locale
        formatLocale: currencyConfig,
        timeFormatLocale: timeConfig,
      });
    };

    watchEffect(async () => {
      try {
        const { view } = await mountChart();

        if (chartData) {
          const getChartImg = async () => {
            await view.width(chartData.reportWidth || 1000);
            const code = await view.toImageURL('png');
            mountChart();

            return code;
          };
          setChartImageGetter(props.id, getChartImg);
        }
      } catch (err) {
        emit('error', err);
      }
    });

    if (chartData) {
      onUnmounted(() => {
        setChartImageGetter(props.id, null);
      });
    }
  },
};
</script>
<template>
  <div :class="{ 'pointer-events-none': disableHover }">
    <div
      :id="id"
      class="chart-view w-full"
    />
  </div>
</template>
